import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./assets/css/plugins/pe-icon-7-stroke.css";
import "./assets/css/plugins/fontawesome-all.min.css";
import "./assets/css/plugins/themify-icons.css";
import "./assets/css/style.css";
import "./assets/css/style1.css";
import "./assets/css/plugins.css";
import GlobalStyle from "./common/GlobalStyle";
import AnimatedCursor from "react-animated-cursor";
// import "./assets/css/plugins/magnific-popup.css";
// import "./assets/css/plugins/swiper.min.css";
// import "./assets/css/base.css";
// import "./assets/css/plugins/YouTubePopUp.css";
// import Cursor from "./common/Cursor";
// import "./assets/css/plugins/justifiedGallery.min.css";

//PAGES
import Home from "./Pages/Home";
import GalleryPage from "./Pages/Gallery";
import StudentProjectListPage from "./Pages/StudentProjects";
import ProjectListsPage from "./Pages/ProjectListsPage";
import PsgIap from "./Pages/PsgIap";
import Trust from "./Pages/Trust";
import Adminstratio from "./Pages/Adminstration";
import StatutoryCommittee from "./Pages/StatutoryCommittee";
// new submenu
import ApprovalAffiliations from "./Pages/ApprovalAffiliations";
import Factsandfigures from "./Pages/Factsandfigures";
import CoreFaculty from "./Pages/Corefaculty";
import Visitingfaculty from "./Pages/Visitingfaculty";
import Alliedfaculty from "./Pages/Alliedfaculty";
import Administrativestaff from "./Pages/Administrativestaff";
import Principalll from "./Pages/Principalll";
import Expertpanelmembers from "./Pages/Expertpanelmembers";
import Designchair from "./Pages/Designchair";
import Syllabus from "./Pages/Syllabus";
import Academiccalendar from "./Pages/Academiccalendar";
import Academictimetable from "./Pages/Academictimetable";
import Programs from "./Pages/Programs";
import MonthlyLectureSeriess from "./Pages/MonthlyLectureSeriess";
import Nasaindex from "./Pages/Nasaindex";
import ConnectWithusIndex from "./Pages/ConnectWithus";
import Iqacindex from "./Pages/Iqacindex";
import AdmissionMainmenu from "./Pages/AdmissionMainmenu";
import Workindex from "./Pages/Workindex";
import ListPageNewsandEventsIndex from "./Pages/ListPageNewsandEvents";
import CurricularIndex from "./Pages/CurricularIndex";
import CoCurricularIndex from "./Pages/CoCurricularIndex";
import ExtraCurricularIndex from "./Pages/ExtraCurricularIndex";
import CollaborationIndex from "./Pages/CollaborationIndex";
import EditorialIndex from "./Pages/EditorialIndex";
import ExamcellIndex from "./Pages/ExamcellIndex";
import StatutoryDetail from "./Pages/StatutoryDetail";
import InfrastructureIndex from "./Pages/InfrastructureIndex";
import ClubsIndex from "./Pages/ClubsIndex";
import ArchiveIndex from "./Pages/ArchiveIndex";
import AnnualReports from "./Pages/AnnualReports";
import StudyTourIndex from "./Pages/StudyTourIndex";
import SiteVisitAndFeldVisitIndex from "./Pages/SiteVisitAndFieldVisitIndex";
import SymposiumIndex from "./Pages/SymposiumIndex";
import NotFound404Page from "./Pages/NotFound404Page";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AntiRaggingCommittee from "./components/Submenu/StatutoryCommittee/AntiRaggingCommittee";
import InternalComplaintsCommittee from "./components/Submenu/StatutoryCommittee/InternalComplaintsCommittee";
import StudentsGrievanceCommittee from "./components/Submenu/StatutoryCommittee/StudentsGrievanceCommittee";
import DisciplineWelfareCommittee from "./components/Submenu/StatutoryCommittee/DisciplineWelfareCommittee";
import WomenEmpowermentCell from "./components/Submenu/StatutoryCommittee/WomenEmpowermentCell";
import AntiDrugCommittee from "./components/Submenu/StatutoryCommittee/AntiDrugCommittee";
//import ApprovalandAffiliations  from "./components/Submenu/Approval & Affiliations/ApprovalandAffiliations";
import Template1 from "./components/Submenu/StatutoryCommittee/Template1";
import Template2 from "./components/Submenu/StatutoryCommittee/Template2";




function App() {
  return (
    <BrowserRouter >
      {/* <BrowserRouter basename="/test" */}
      
     
      <div className="crev-agency">
        <div className="App">
          <AnimatedCursor
            color="128, 128, 128"
            innerSize={0}
            // outerSize={8}
            outerAlpha={0.2}
            innerScale={0.7}
            outerScale={6}
            animationDuration={0.01}
            showSystemCursor={true}
          />

          {/* <Cursor /> */}
          <GlobalStyle />
          <div id="smooth-content">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/Gallery" element={<GalleryPage />} />
              <Route
                exact
                path="/academic-spotlight-list"
                element={<ProjectListsPage />}
              />
              <Route
                exact
                path="/academic-spotlight-project-detail/:projectname"
                element={<StudentProjectListPage />}
              />
              <Route exact path="/about-us/psg-iap" element={<PsgIap />} />
              <Route exact path="/about-us/the-trust" element={<Trust />} />
              <Route
                exact
                path="/about-us/administration"
                element={<Adminstratio />}
              />
                <Route
                exact
                path="/about-us/statutory-committee"
                element={<StatutoryCommittee />}
              />
             <Route path="/about-us/statutory-committee/:committeeSlug" element={<StatutoryDetail />} /> 
               <Route
                exact
                path="/about-us/Approval-Affiliations"
                element={< ApprovalAffiliations/>}
              />
              {/* Main statutory committee page */}
        {/* <Route path="/about-us/statutory-committee" element={<StatutoryCommittee />} /> */}

  {/* Static components via their own routes */}
  <Route path="/about-us/statutory-committee/anti-ragging-committee" element={<AntiRaggingCommittee />} />
  <Route path="/about-us/statutory-committee/internal-complaints-committee" element={<InternalComplaintsCommittee />} />
  <Route path="/about-us/statutory-committee/students-grievance-and-redressal-committee" element={<StudentsGrievanceCommittee />} />
  <Route path="/about-us/statutory-committee/discipline-and-welfare-committee" element={<DisciplineWelfareCommittee />} />
  <Route path="/about-us/statutory-committee/women-empowerment-cell" element={<WomenEmpowermentCell />} />
  <Route path="/about-us/statutory-committee/anti-drug-committee" element={<AntiDrugCommittee />} />
   <Route path="/about-us/statutory-committee/Template_1" element={<Template1 />} />
  <Route path="/about-us/statutory-committee/Template_2" element={<Template2/>} />
 
              <Route
                exact
                path="/about-us/facts-and-figures"
                element={<Factsandfigures />}
              />
              <Route
                exact
                path="/people/core-faculty"
                element={<CoreFaculty />}
              />
              <Route
                exact
                path="/people/visiting-faculty"
                element={<Visitingfaculty />}
              />
              <Route
                exact
                path="/people/allied-faculty"
                element={<Alliedfaculty />}
              />
              <Route
                exact
                path="/people/administrative-staffs"
                element={<Administrativestaff />}
              />
              <Route exact path="/people/principal" element={<Principalll />} />
              <Route
                exact
                path="/people/expert-panel-members"
                element={<Expertpanelmembers />}
              />
              <Route
                exact
                path="/people/design-chair"
                element={<Designchair />}
              />
              <Route exact path="/pedagogy/programs" element={<Programs />} />
              <Route
                exact
                path="/pedagogy/academic-time-table"
                element={<Academictimetable />}
              />
              <Route
                exact
                path="/pedagogy/academic-calendar"
                element={<Academiccalendar />}
              />
              <Route exact path="/pedagogy/syllabus" element={<Syllabus />} />

              <Route
                exact
                path="/learning-events/monthly-lecture-series"
                element={<MonthlyLectureSeriess />}
              />
              <Route exact path="/learning-events/nasa" element={<Nasaindex />} />
              <Route
                exact
                path="/ConnectWithus"
                element={<ConnectWithusIndex />}
              />
              <Route exact path="/iqac" element={<Iqacindex />} />

              <Route exact path="/admissions" element={<AdmissionMainmenu />} />
              <Route exact path="/work-with-us" element={<Workindex />} />
              <Route
                exact
                path="/iap-chronicles"
                element={<ListPageNewsandEventsIndex />}
              />
              <Route exact path="/life-at-campus/curricular" element={<CurricularIndex />} />
              <Route
                exact
                path="/life-at-campus/co-curricular"
                element={<CoCurricularIndex />}
              />

              <Route
                exact
                path="/life-at-campus/extra-curricular"
                element={<ExtraCurricularIndex />}
              />

              <Route
                exact
                path="/life-at-campus/collaboration"
                element={<CollaborationIndex />}
              />

              <Route exact path="/learning-events/editorial" element={<EditorialIndex />} />
              <Route exact path="/pedagogy/exam-cell" element={<ExamcellIndex />} />
              <Route
                exact
                path="/infrastructure"
                element={<InfrastructureIndex />}
              />
             
              <Route exact path="/learning-events/clubs" element={<ClubsIndex />} />
              <Route exact path="/pedagogy/archive" element={<ArchiveIndex />} />
              <Route exact path="/reports" element={<AnnualReports />} />
              <Route exact path="/learning-events/educational-tour" element={<StudyTourIndex />} />

              <Route exact path="/learning-events/site-visits-field-visits" element={<SiteVisitAndFeldVisitIndex />} />
              <Route exact path="/learning-events/symposium" element={<SymposiumIndex />} />
              <Route path="*" element={<NotFound404Page />} />
            </Routes>
            {/* ToastContainer should be outside Routes but inside Router */}
            <ToastContainer
              position="bottom-right"
              autoClose={7000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </div>
        </div>
      </div>
                
    </BrowserRouter>
  );
}

export default App;
